// extracted by mini-css-extract-plugin
module.exports = {"widgetCard":"addWidgets_widgetCard_-tCfGZK","thumb":"addWidgets_thumb_CUUUxnt","menuWrapper":"addWidgets_menuWrapper_35W534H","menuItem":"addWidgets_menuItem_1qDJy6f"};